<template>
  <div class="app-container container px-md-0">
    <div :class="{ 'has-bottom-bar': showBottomBar }">
      <router-view />
    </div>
    <agent-bottom-bar v-if="showBottomBar" />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import AgentBottomBar from "components/AgentBottomBar.vue";
import { Getter } from "vuex-class";
import { User } from "models";
@Component({ components: { AgentBottomBar } })
export default class Container extends Vue {
  @Getter currentUser?: User;

  get showBottomBar() {
    return this.currentUser && this.currentUser.isAgent;
  }
}
</script>

<style scoped lang="scss">
@import "../styles/shared/variables";

.has-bottom-bar {
  margin-bottom: calc(#{$bottom-bar-height} * 3);
}
</style>
